import React from "react";
import './style.css'
import BG from "../../Images/New/AllFeature/Invoice-bro.svg";

const Facilitys = () => {
  return (
    <>
      <div className="flex justify-center bg-[#ffffff] pb-14">
        <div className="max-w-7xl bg-[#e6f7ff] rounded-xl shadow-xl px-3 sm:px-[50px] pt-10 pb-16">
          <div className="text-center pb-7">
            <p className="text-5xl text-black font-bold">
              Simplify{" "}
              <span
                className=""
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                E-Invoicing
              </span>{" "}
              Software
            </p>
          </div>
          <div className="sm:block hidden">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center">
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border shadow-2xl border-[#02aee6] duration-150 hover:shadow-lg ">
                  <p
                    id="Box_text"
                    className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[400px]"
                  >
                    E-Invoice Quick Upload
                  </p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border shadow-2xl border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p
                    id="Box_text"
                    className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[400px]"
                  >
                    Debit/Credit Note of E-Invoice
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-3 items-center">
              <div className="flex justify-start items-center">
                <div className="bg-[#ffffff] py-2 pl-4 rounded-lg border shadow-2xl border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p
                    id="Box_text"
                    className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[330px]"
                  >
                    Print E-Invoice
                  </p>
                </div>
              </div>
              <div className="border bg-white border-blue-400 p-1 rounded-xl shadow-2xl">
                <img src={BG} alt="" className="w-[620px] rounded-lg" />
              </div>
              <div className="flex justify-end items-center">
                <div className="bg-[#ffffff] py-2 pl-4 rounded-lg border shadow-2xl border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p
                    id="Box_text"
                    className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[330px]"
                  >
                    Import JSON/Excel of E-Invoice
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mt-3">
              <div className="flex items-center">
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border shadow-2xl border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p
                    id="Box_text"
                    className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[400px]"
                  >
                    Cancel E-Invoice
                  </p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="flex items-center">
                  <div className="bg-[#ffffff] py-2 px-4 rounded-lg border shadow-2xl border-[#02aee6]  duration-150 hover:shadow-lg ">
                    <p
                      id="Box_text"
                      className="mb-0 text-3xl text-center text-[#192027] font-semibold hover:text-[#0285b1] w-[400px]"
                    >
                      Generate bulk e-invoice JSON
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sm:hidden block">
            <div>
              <div className="border border-blue-400 p-1 rounded-xl shadow-2xl">
                <img src={BG} alt="" className="sm:w-[320px] rounded-lg" />
              </div>
              <div className="space-y-3 mt-3">
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    E-Invoice Quick Upload
                  </p>
                </div>
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    Debit/Credit Note of E-Invoice
                  </p>
                </div>
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    Generate bulk e-invoice JSON
                  </p>
                </div>
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    Import JSON/Excel of E-Invoice
                  </p>
                </div>
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    Print E-Invoice
                  </p>
                </div>
                <div className="bg-[#ffffff] py-2 px-4 rounded-lg border border-[#02aee6]  duration-150 hover:shadow-lg ">
                  <p className="mb-0 text-xl text-[#192027] font-semibold hover:text-[#02aee6]">
                    Cancel E-Invoice
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Facilitys;
